import { Controller } from "@hotwired/stimulus"

// Interactive star rating (1-5). Renders 5 clickable SVG stars.
// Targets: hiddenField (stores numeric value), label (shows hover text)
// Dispatches star-rating:change with { value, builderId, field }
export default class extends Controller {
  static targets = ["hiddenField", "label"]
  static values = {
    rating: { type: Number, default: 0 },
    builderId: String,
    field: String
  }

  connect() {
    this._render()
  }

  ratingValueChanged() {
    this._render()
  }

  select(event) {
    const value = parseInt(event.currentTarget.dataset.starValue)
    this.ratingValue = value
    if (this.hasHiddenFieldTarget) this.hiddenFieldTarget.value = value
    if (this.hasLabelTarget) this.labelTarget.textContent = this._legend(value)

    this.dispatch("change", {
      detail: { value, builderId: this.builderIdValue, field: this.fieldValue }
    })
  }

  mouseenter(event) {
    const value = parseInt(event.currentTarget.dataset.starValue)
    this._highlight(value)
    if (this.hasLabelTarget) this.labelTarget.textContent = `${value} - ${this._legend(value)}`
  }

  mouseleave() {
    this._highlight(this.ratingValue)
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.ratingValue ? this._legend(this.ratingValue) : ""
    }
  }

  _render() {
    const container = this.element.querySelector("[data-stars]")
    if (!container) return
    this._highlight(this.ratingValue)
  }

  _highlight(upTo) {
    const stars = this.element.querySelectorAll("[data-star-value]")
    stars.forEach(star => {
      const val = parseInt(star.dataset.starValue)
      const path = star.querySelector("path")
      if (path) path.setAttribute("fill", val <= upTo ? "#f5a623" : "#d1d5db")
    })
  }

  _legend(value) {
    const legends = { 1: "Poor", 2: "Below Average", 3: "Average", 4: "Good", 5: "Excellent" }
    return legends[value] || ""
  }
}
